// Play pause btns
Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function () {
    return !!(
      this.currentTime > 0 &&
      !this.paused &&
      !this.ended &&
      this.readyState > 2
    );
  },
});

/**
 * Get Pause button elements
 * @param {String} [videoId] - Optional: The ID of the associated video
 * @returns
 */
export function getPauseButtons(videoId) {
  if (typeof videoId === 'undefined') {
    return document.querySelectorAll('.js-vid-pause-btn');
  } else {
    return document.querySelectorAll(
      '.js-vid-pause-btn[aria-controls="' + videoId + '"]'
    );
  }
}

export function setPauseButtonsState(state, videoId) {
  // Get all pause buttons for this video
  const buttons = getPauseButtons(videoId);

  if (state === 'playing') {
    buttons.forEach((el) => {
      el.dataset.playing = 'true';
      el.setAttribute('aria-label', 'Pause video');
    });
  } else if (state === 'paused') {
    buttons.forEach((el) => {
      el.dataset.playing = 'false';
      el.setAttribute('aria-label', 'Play video');
    });
  }
}

/**
 * Set video playing state
 *
 * @param {String} state - playing|paused
 * @param {Element} video - Video element to control
 * @param {String} videoId - The ID of the video
 */
export function setVideoState(state, video, videoId) {
  if (state === 'playing') {
    video.play();
  } else if (state === 'paused') {
    video.pause();
  }

  setPauseButtonsState(state, videoId);
}

function setupPauseButtons() {
  const buttons = getPauseButtons();

  buttons.forEach((el) => {
    // Get connected video
    const videoId = el.getAttribute('aria-controls');
    const video = document.querySelector('#' + videoId);

    el.addEventListener('click', function () {
      // Get current play state
      const buttonPlaying = el.dataset.playing;

      if (buttonPlaying === 'true') {
        setVideoState('paused', video, videoId);
      } else {
        setVideoState('playing', video, videoId);
      }
    });
  });
}

// Reduce motion

function pauseAutoplayVideos() {
  const autoplayVideos = document.querySelectorAll(
    'video[autoplay]:not(.js-vid-has-pause-btn)'
  );
  const playpauseBtnVideos = document.querySelectorAll('.js-vid-has-pause-btn');

  autoplayVideos.forEach((el) => {
    el.pause();
  });

  playpauseBtnVideos.forEach((el) => {
    const videoId = el.getAttribute('id');

    setVideoState('paused', el, videoId);
  });
}

function reduceMotionVideos() {
  const reduceMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!reduceMotionMq || reduceMotionMq.matches) {
    pauseAutoplayVideos();
  }

  reduceMotionMq.addEventListener('change', () => {
    if (reduceMotionMq.matches) {
      pauseAutoplayVideos();
    }
  });
}

// Video thumbnails

function getVideos() {
  const videos = document.querySelectorAll('.video-placeholder__thumbnail');
  return videos;
}

function setupVideos() {
  // watch video
  const videos = getVideos();

  videos.forEach((el) => {
    el.addEventListener('click', (e) => {
      const isHosted = el.getAttribute('data-hosted') === 'true' ?? false;
      el.nextElementSibling.hidden = false;
      if (isHosted) {
        el.nextElementSibling.play();
      } else {
        el.nextElementSibling.src = el.nextElementSibling.dataset.src;
      }
      if (el.querySelector('.video-placeholder__play')) {
        el.querySelector('.video-placeholder__play').remove();
      }
      el.classList.add('video-placeholder__thumbnail--playing');
      return false;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setupVideos();
  setupPauseButtons();
  reduceMotionVideos();
});
